// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.762 17.1765C12.4258 19.8126 7.56978 19.5906 4.48959 16.5104C1.17014 13.191 1.17014 7.80905 4.48959 4.48959C7.80905 1.17014 13.191 1.17014 16.5104 4.48959C19.5907 7.56987 19.8126 12.4261 17.1763 15.7623L22.5206 21.1067L21.1064 22.5209L15.762 17.1765Z"}}]};

const SearchFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'search-filled',
    ref,
    icon: element,
  },
));

SearchFilledIcon.displayName = 'SearchFilledIcon';

export default SearchFilledIcon;
